import { createSubscriptionHook } from '~/shared/providers/api';

export const useScaleEventsSubscription = createSubscriptionHook(
  'iot.scaleEvents',
  () => ({
    iotScaleEvents: {
      id: true,
      name: true,
      status: true,
    },
  }),
  {
    select: ({ iotScaleEvents }) => iotScaleEvents,
  },
);
